/* unplugin-vue-components disabled */import { render } from "./user_collect.vue?vue&type=template&id=65f311a5&scoped=true"
import script from "./user_collect.vue?vue&type=script&lang=js"
export * from "./user_collect.vue?vue&type=script&lang=js"

import "./user_collect.vue?vue&type=style&index=0&id=65f311a5&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f311a5"]])

export default __exports__